import { render, staticRenderFns } from "./UpdatePhoneNumberNew.vue?vue&type=template&id=c0d0f29a&"
import script from "./UpdatePhoneNumberNew.vue?vue&type=script&lang=ts&"
export * from "./UpdatePhoneNumberNew.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePhoneNumberNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports